import Vue from 'vue'
import {
	Button,
	Container,
	Header,
	Aside,
	Main,
	Menu,
	Submenu,
	menuItem,
	MenuItemGroup,
	Breadcrumb,
	BreadcrumbItem,
	Card,
	Table,
	TableColumn,
	Pagination,
	Upload,
	Row,
	Input,
	Col,
	Form,
	FormItem,
	Message,
	MessageBox,
	Tag,
	Dialog,
	Tabs,
	TabPane
} from 'element-ui'

Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox.confirm
Vue.use(Button)
Vue.use(Container)
Vue.use(Header)
Vue.use(Aside)
Vue.use(Main)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(menuItem)
Vue.use(MenuItemGroup)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Card)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Pagination)
Vue.use(Upload)
Vue.use(Row)
Vue.use(Input)
Vue.use(Col)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Tag)
Vue.use(Dialog)
Vue.use(Tabs)
Vue.use(TabPane)